import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiError, ApiRequestService, MAT_ICON, TOAST_STATE, ToastmessageService } from '@prekog/common-ui';
import { catchError, throwError } from 'rxjs';
import { GetSpecialitiesResponse } from '../consultation/getspecialitiesresponse';
import { Speciality } from '../consultation/speciality';
import { SpecialityWithPrices } from '../consultation/specialitywithprices';

@Component({
    selector: 'pf-pricelist',
    templateUrl: './pricelist.component.html',
    styleUrls: ['./pricelist.component.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule, RouterModule]
})
export class PricelistComponent implements OnInit {
    chosenSpecialityId = 0;
    getSpecialitiesUrl = '/regenero/get-specialities';
    hasSpecialityChosen = false;
    regeneroBaseUrl = '';

    showExamination = false;
    specialities?: Speciality[];

    constructor(
        public router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }

    ngOnInit(): void {
        this._apiRequestService
            .sendRequest<{}, GetSpecialitiesResponse>(this.regeneroBaseUrl, {}, true, this.getSpecialitiesUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const apiError: ApiError = error.error as ApiError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();

                        this.router.navigateByUrl('/');
                    });
                })
            )
            .subscribe((response: GetSpecialitiesResponse) => {
                this.specialities = response.specialityList;
            });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    showExaminationElement() {
        this.specialities!.forEach((speciality) => {
            speciality.hasSpecialityChosen = false;
            speciality.isVisible = false;
        });
        this.showExamination = !this.showExamination;
    }

    chooseOneSpeciality(speciality: SpecialityWithPrices) {
        this.chosenSpecialityId = speciality.speciality?.id!;
        speciality.hasSpecialityChosen = !speciality.hasSpecialityChosen;
        speciality.isVisible = !speciality.isVisible;
    }
}
